module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_j_albino.03813e88.png";